import { cn } from "@bem-react/classname";
import { fetchTypes, getCatalog, haveTheory, maxnumlen, selectCatalog } from "modules/Catalog";
import { useDeskListHideOnTouch } from "pages/App/components/DeskList";
import { FC } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useConstructor } from "utils";
import CatalogSelector from "./CatalogSelector";
import Theme from "./Theme";
import TypeSelector from "./TypeSelector";
import StatsSelector from "./StatsSelector";
import "./Catalog.scss"
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const Catalog: FC = () => {
    const dispatch = useDispatch()
    useConstructor(() => {
        if (!window.hasOwnProperty('jQuery')){
            const jquery = document.createElement('script')
            jquery.src = '/js/jquery.min.js'
            document.head.appendChild(jquery)  
        }
        if (!window.jQuery.fn.hasOwnProperty('dialog')){
            const jqui = document.createElement('script')
            jqui.src = '/js/jquery-ui.js'
            document.head.appendChild(jqui)
            const jquicss = document.createElement('link')
            jquicss.rel  = 'stylesheet';
            jquicss.type = 'text/css';
            jquicss.href = '/js/jquery-ui.min.css';
            jquicss.media = 'all';
            document.head.appendChild(jquicss)
        }
      dispatch(fetchTypes())
    });
    const cnCatalog = cn('Catalog')
    useDeskListHideOnTouch()
    const data = useSelector(selectCatalog)
    const catalog = getCatalog(data)
    if (!catalog) {
        return <span>{data.error}</span>
    }
    const haveT = haveTheory(catalog.themes)
    const numLen = maxnumlen(catalog.themes)
    //console.log(catalog)
    return (<div className={cnCatalog()}>
        <TypeSelector/>
        <CatalogSelector/>
        <StatsSelector/>
        {data.error ? <span>{data.error}</span> : ''}
        <DndProvider backend={HTML5Backend}>
        {catalog.additional ? 
        <>{catalog.themes.slice(0, catalog.additional).map((el, i)=> <Theme ipath={[i]} key={i} theme={el} haveTheory={haveT} numLen={numLen}/>)}
        <div className={cnCatalog('additional')}>Дополнительные задания для подготовки</div>
        {catalog.themes.slice(catalog.additional).map((el, i)=> <Theme ipath={[i]} key={i} theme={el} haveTheory={haveT} numLen={numLen}/>)}</>
        : <>{catalog.themes.map((el, i)=> <Theme ipath={[i]} key={i} theme={el} haveTheory={haveT} numLen={numLen}/>)}</> }
        </DndProvider>
    </div>)
}

export default Catalog